





























































































































import ALPage from '@/components/core/Page/ALPage.vue';
import CountryFlag from 'vue-country-flag';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import FormTemplateDialog from '@/components/form-builder/FormTemplateDialog.vue';
import EmployeeFormSubmissionSearchFilter from '@/components/employee-form/EmployeeFormSubmissionSearchFilter.vue';
import FormBuilderStatusDisplay from '@/components/form-builder/FormBuilderStatusDisplay.vue';

import { mapActions, mapGetters } from 'vuex';
import { IEmployeeFormSubmission, IFormTemplateData } from '@/models';
import { ErrorManager } from '@/models/error';

import moment from 'moment';

import mixins from '@/utils/mixins';
import Functions from '@/mixins/functions';
import auth from '@/mixins/auth';

const baseMixins = mixins(Functions, auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    formTemplateDialog: InstanceType<typeof FormTemplateDialog>;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    components: {
      ALPage,
      CountryFlag,
      ConfirmationDialog,
      ErrorAlert,
      FormTemplateDialog,
      EmployeeFormSubmissionSearchFilter,
      FormBuilderStatusDisplay
    },

    data() {
      return {
        loading: false,
        isSearchFilterActive: false,

        errorMessage: '',
        detailErrorMessage: '',

        deleteErrorMessage: '',

        search: '',

        sortBy: 'id',
        sortDesc: true,

        headers: [
          {
            text: '#',
            sortable: false,
            value: 'index'
          },
          {
            text: 'Owner',
            sortable: false,
            value: 'owner'
          },
          {
            text: 'Title',
            sortable: false,
            value: 'title'
          },
          {
            text: 'Description',
            sortable: false,
            value: 'description'
          },
          {
            text: 'Last Modified',
            sortable: false,
            value: 'updated_at'
          },
          {
            text: 'Status',
            sortable: false,
            align: 'center',
            value: 'state'
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            value: 'actions'
          }
        ],

        selectedFormTemplate: {} as IFormTemplateData,
        deleteDialog: false
      };
    },

    computed: {
      ...mapGetters({
        formTemplates: 'formTemplate/getFormTemplates'
      })
    },

    mounted() {
      this.loading = true;

      this.fetchFormTemplates()
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    methods: {
      moment,

      ...mapActions({
        fetchEmployeeFormSubmissions:
          'employeeForm/fetchEmployeeFormSubmissions',
        fetchFormTemplates: 'formTemplate/fetchFormTemplates',
        deleteFormTemplate: 'formTemplate/deleteFormTemplate'
      }),

      goToDetailPage(submission: IEmployeeFormSubmission) {
        this.$router.push({
          name: 'form-template-detail',
          params: {
            id: String(submission.id)
          }
        });
      },

      openFormDialog() {
        this.$refs.formTemplateDialog.open();
      },

      openFormTemplateDeleteDialog(template: IFormTemplateData) {
        this.selectedFormTemplate = template;
        this.deleteDialog = true;
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      closeDeleteDialog() {
        this.deleteDialog = false;
      },

      removeFormTemplate(selectedFormTemplate: IFormTemplateData) {
        this.loading = true;

        this.deleteFormTemplate(selectedFormTemplate.id)
          .then(() => {
            this.closeDeleteDialog();
          })
          .catch(error => {
            this.deleteErrorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  });
